import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  Typography,
  Button,
} from "@mui/material";
import InputsForm from "./InputsForm";
import { Cancel } from "@mui/icons-material";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const AddInputs = ({ mode, defaultData, open, handleClose }) => {
  const [isDirty, setIsDirty] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleAttemptClose = () => {
    if (isDirty) {
      setConfirmOpen(true);
    } else {
      handleClose();
    }
  };

  const handleConfirmDiscard = () => {
    setConfirmOpen(false);
    setIsDirty(false);
    handleClose();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleAttemptClose}
        fullScreen
        PaperProps={{
          sx: {
            background: "#fafafa",
            ".dark &": { background: "#0f172a" },
          },
        }}
      >
        <DialogTitle sx={{ p: 0 }}>
          <Box sx={{
            background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
            px: 3, py: 2,
            display: "flex", alignItems: "center", justifyContent: "space-between",
          }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Inventory2Icon sx={{ color: "#fff", fontSize: 24 }} />
              <Typography sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, color: "#fff", fontSize: "1.1rem" }}>
                {mode === "POST" ? "Nueva Entrada" : "Editar Entrada"}
              </Typography>
            </Box>
            <IconButton onClick={handleAttemptClose} sx={{ color: "#fff", "&:hover": { background: "rgba(255,255,255,0.15)" } }}>
              <Cancel />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <InputsForm
            mode={mode}
            open={open}
            handleClose={handleClose}
            handleCancel={handleAttemptClose}
            onDirtyChange={setIsDirty}
          />
        </DialogContent>
      </Dialog>

      {/* Diálogo de confirmación: cambios sin guardar */}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, pb: 1 }}>
          <WarningAmberIcon sx={{ color: "#f43f5e", fontSize: 22 }} />
          <Typography sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: "1rem" }}>
            Cambios sin guardar
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.9rem", color: "#475569" }}>
            Tienes cambios sin guardar. ¿Estás seguro de que deseas cerrar sin guardar?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2.5, gap: 1 }}>
          <Button
            onClick={() => setConfirmOpen(false)}
            variant="outlined"
            sx={{
              fontFamily: "'Poppins', sans-serif", fontWeight: 600, borderRadius: 2,
              borderColor: "#f43f5e", color: "#f43f5e",
              "&:hover": { borderColor: "#e11d48", background: "#fff0f6" },
            }}
          >
            Seguir editando
          </Button>
          <Button
            onClick={handleConfirmDiscard}
            variant="contained"
            sx={{
              fontFamily: "'Poppins', sans-serif", fontWeight: 600, borderRadius: 2,
              background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
              "&:hover": { background: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
            }}
          >
            Cerrar sin guardar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddInputs;
